module.exports = __webpack_public_path__ + "static/media/how-we-fight-for-our-lives.6710ac71.jpg";